
import { useState } from "react";
import { Card, Button } from "react-bootstrap";
import ModalApp from "./modalApp";
import ModalCard from "./modalCard";


function CardComponent({ project }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <div className="mx-auto" style={{ marginBottom: 20 }}>
            <Card style={{ width: '15rem', height: "11rem" }}>
                <Card.Body style={{ alignContent: "center" }}>
                    <Card.Title>{project.name}</Card.Title>
                    <Card.Text>
                        {project.text}
                    </Card.Text>
                </Card.Body>
                <Card.Footer>
                    <Button style={{ backgroundColor: "#000", border: 0 }} onClick={handleShow}>Show more</Button>
                </Card.Footer>
            </Card>
            {
                project.type === "web" ?
                    <ModalCard show={show} handleClose={handleClose} handleShow={handleShow} project={project} /> :
                    <ModalApp show={show} handleClose={handleClose} handleShow={handleShow} project={project} />
            }
        </div>
    );
}

export default CardComponent;
